import React from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <div style={{ background: 'var(--primary)', padding: '40px 0', borderBottom: '3px solid var(--accent)' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h1 style={{ fontFamily: 'var(--font-heading)', color: 'white', fontSize: '2.5rem' }}>About NewsBuzz Today</h1>
          <p style={{ color: 'var(--gold)', fontFamily: 'var(--font-mono)', marginTop: '8px' }}>Breaking News, Every Moment.</p>
        </div>
      </div>
      <main className="container" style={{ maxWidth: '800px', padding: '60px 24px' }}>
        <div style={{ background: 'white', borderRadius: 'var(--radius-lg)', padding: '48px', boxShadow: 'var(--shadow-md)' }}>
          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.8rem', marginBottom: '20px' }}>Our Mission</h2>
          <p style={{ lineHeight: '1.9', color: 'var(--text-secondary)', marginBottom: '20px' }}>
            NewsBuzz Today is committed to delivering accurate, fair, and in-depth journalism that keeps our readers informed about local, national, and global events. We believe in the power of a free press to hold institutions accountable and amplify the voices that matter.
          </p>
          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.8rem', marginBottom: '20px', marginTop: '40px' }}>Our Values</h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            {[['🎯 Accuracy', 'We fact-check every story before publication.'],
              ['⚖️ Fairness', 'We present all sides of every story.'],
              ['🔍 Depth', 'We go beyond headlines to tell the full story.'],
              ['🌍 Perspective', 'We cover news that matters to your community.']
            ].map(([title, desc]) => (
              <div key={title} style={{ padding: '20px', background: 'var(--gray-100)', borderRadius: 'var(--radius-md)', borderLeft: '4px solid var(--accent)' }}>
                <h3 style={{ fontFamily: 'var(--font-heading)', marginBottom: '8px' }}>{title}</h3>
                <p style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>{desc}</p>
              </div>
            ))}
          </div>
          <div style={{ marginTop: '40px', padding: '24px', background: 'var(--secondary)', borderRadius: 'var(--radius-md)', textAlign: 'center' }}>
            <h3 style={{ fontFamily: 'var(--font-heading)', color: 'white', marginBottom: '10px' }}>Contact Us</h3>
            <p style={{ color: 'var(--gray-400)', fontFamily: 'var(--font-mono)', fontSize: '0.85rem' }}>newsbuzztoday2825@gmail.com</p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}